// 1. Array of all the new locations for ServiceNow
const serviceNowLocations = [
    { name: "Sydney", slugName: "sydney" },
    { name: "Bangalore", slugName: "bangalore" },
    { name: "Pune", slugName: "pune" },
    { name: "San Francisco", slugName: "san-francisco" },
    { name: "New York", slugName: "new-york" },
    { name: "Dubai", slugName: "dubai" },
    { name: "Saudi Arabia", slugName: "saudi-arabia" },
    { name: "Singapore", slugName: "singapore" },
    { name: "San Jose", slugName: "san-jose" },
    { name: "Germany", slugName: "germany" },
    { name: "Paris", slugName: "paris" },
    { name: "Sweden", slugName: "sweden" }
];

const dynamicServiceNowData = serviceNowLocations.map(location => ({
    id: `servicenow-consulting-${location.slugName}`,
    slug: `/servicenow-consulting-${location.slugName}`,
    hero: {
        title: `ServiceNow Consulting in ${location.name}`,
        text: "Optimize Workflows. Enhance IT Service Delivery.",
        imgData: "/assets/sales/bg1.jpg" // Change image paths if needed
    },
    empower: {
        heading: `Empower Your Enterprise with Expert ServiceNow Solutions in ${location.name}`,
        descriptions: [
            `Looking for top-tier ServiceNow consulting in ${location.name}? We help organizations transform their IT service management, streamline operations, and automate digital workflows. From initial implementation to custom app development, our certified ServiceNow experts deliver solutions that modernize your entire IT infrastructure.`,
            `Whether you need to optimize ITSM, automate HR processes, or integrate third-party applications, our ${location.name}-based consulting team ensures enhanced productivity, reduced operational costs, and seamless enterprise-wide service delivery.`
        ],
        image: "/assets/sales/img1.png"
    },
    servicesCarousel: {
        heading: `Our ServiceNow Services in ${location.name}`,
        items: [
            {
                id: 1,
                title: "ServiceNow\nImplementation",
                desc: "End-to-end setup and configuration of ServiceNow ITSM, ITOM, and CSM modules tailored to your business processes. We ensure a smooth deployment with minimal disruption to your daily operations."
            },
            {
                id: 2,
                title: "Platform\nCustomization",
                desc: "Build custom scoped applications and modify existing workflows to align the Now Platform perfectly with your enterprise goals. We tailor dashboards, portals, and service catalogs for maximum user adoption."
            },
            {
                id: 3,
                title: "ServiceNow\nIntegrations",
                desc: "Seamlessly connect ServiceNow with your existing tools, ERPs (like SAP or Oracle), and cloud infrastructure to create a unified data ecosystem and automate cross-platform workflows."
            },
            {
                id: 4,
                title: "Managed Support\n& Upgrades",
                desc: "Ongoing platform administration, version upgrades, health checks, and dedicated technical support to keep your ServiceNow environment secure, optimized, and running flawlessly."
            },
            {
                id: 5,
                title: "Workflow\nAutomation",
                desc: "Eliminate manual tasks and bottlenecks by digitizing your enterprise workflows. We help you leverage ServiceNow's automation capabilities to boost efficiency across IT, HR, and customer service departments."
            }
        ]
    },
    whyChooseUs: {
        heading: `Why Choose Our ServiceNow Experts in ${location.name}?`,
        image: "/assets/sales/img2.png",
        reasons: [
            "Certified ServiceNow Implementation Specialists",
            `Proven track record with ${location.name}-based enterprises`,
            "Deep expertise in ITSM, ITOM, and Custom Apps",
            "Seamless data migration and risk-free upgrades",
            "Agile project delivery and transparent communication",
            "Round-the-clock managed support and maintenance",
            "Scalable solutions designed for future growth"
        ]
    },
    industriesServe: {
        heading: "Industries We Serve",
        description: `We deliver transformational ServiceNow solutions across diverse sectors in ${location.name}, including:`,
        backgroundImage: "/assets/sales/bg2.png",
        industriesList: [
            "Banking & Financial Services",
            "Healthcare & Pharmaceuticals",
            "IT & Telecommunications",
            "Manufacturing & Supply Chain",
            "Retail & E-commerce",
            "Government & Public Sector",
            "Education & EdTech",
            "Media & Entertainment"
        ]
    },
    trustSection: [
        {
            heading: "ServiceNow Transformation for Enterprises",
            description: "For large organizations aiming to break down departmental silos, our ServiceNow consulting provides a unified platform to manage IT, HR, Customer Service, and Security workflows seamlessly. We ensure your digital transformation journey is smooth, secure, and highly ROI-driven."
        },
        {
            heading: `Why ${location.name} Enterprises Trust Us`,
            description: `We combine global ServiceNow best practices with a deep understanding of the local market dynamics. Our commitment to delivering scalable, user-friendly, and cost-effective solutions has made us a trusted technology partner for businesses across ${location.name}.`
        }
    ],
    processSection: {
        heading: "Our Implementation Process",
        steps: [
            {
                id: "01",
                title: "Requirement Analysis",
                desc: "We map your current IT workflows and identify areas for automation and improvement."
            },
            {
                id: "02",
                title: "Strategy & Architecture",
                desc: "Designing a scalable ServiceNow architecture and a phased implementation roadmap."
            },
            {
                id: "03",
                title: "Configuration & Dev",
                desc: "Building out workflows, custom applications, and configuring essential platform modules."
            },
            {
                id: "04",
                title: "Testing & Integration",
                desc: "Rigorous quality assurance, UAT, and connecting with your existing third-party systems."
            },
            {
                id: "05",
                title: "Deployment & Training",
                desc: "Ensuring a smooth go-live followed by comprehensive team training and ongoing support."
            }
        ]
    }
}));

export const salesData = [
    {
        id: "servicenow-consulting-mumbai",
        slug: "/servicenow-consulting-mumbai",
        hero: {
            title: "Servicenow Consulting in Mumbai",
            text: "Technology. Transformation. Trust.",
            imgData: "/assets/sales/bg1.jpg"
        },
        empower: {
            heading: "Empower Your Business with Expert Salesforce Solutions in Mumbai",
            descriptions: [
                "Looking for reliable Salesforce services in Mumbai? We help startups, SMEs, and large enterprises streamline their business operations using powerful Salesforce solutions. From implementation to customization and ongoing support, our certified Salesforce experts deliver scalable solutions tailored to your business needs.",
                "Whether you want to improve sales performance, automate customer service, or enhance marketing campaigns, our Salesforce consulting team in Mumbai ensures faster growth, better productivity, and improved customer experiences."
            ],
            image: "/assets/sales/img1.png"
        },
        servicesCarousel: {
            heading: "Our Salesforce Services in Mumbai",
            items: [
                {
                    id: 1,
                    title: "Salesforce\nImplementation",
                    desc: "We help businesses implement Salesforce from scratch with a well-planned strategy. Our team ensures seamless setup, data migration, workflow automation, and system configuration so your business can start using Salesforce quickly and efficiently."
                },
                {
                    id: 2,
                    title: "Salesforce\nCustomization",
                    desc: "Tailor your Salesforce environment to match your unique business workflows. We customize objects, fields, page layouts, and build custom apps to maximize your CRM efficiency and boost user adoption."
                },
                {
                    id: 3,
                    title: "Salesforce\nIntegration Services",
                    desc: "Seamlessly connect Salesforce with your ERP, marketing automation, or third-party applications to create a unified data ecosystem and streamline your business processes."
                }
            ]
        },
        whyChooseUs: {
            heading: "Why Choose Our Salesforce Services in Mumbai?",
            image: "/assets/sales/img2.png",
            reasons: [
                "Certified Salesforce professionals",
                "Custom solutions tailored to your business",
                "Affordable and scalable services",
                "Fast implementation and deployment",
                "Dedicated support team",
                "Experience across multiple industries",
                "Transparent communication and project management"
            ]
        },
        industriesServe: {
            heading: "Industries We Serve",
            description: "We provide Salesforce solutions for a wide range of industries in Mumbai, including:",
            backgroundImage: "/assets/sales/bg2.png",
            industriesList: [
                "IT & Software Companies",
                "Education & Training Institutes",
                "Real Estate Businesses",
                "Financial Services",
                "Healthcare & Clinics",
                "Logistics & Transportation",
                "E-commerce Companies",
                "Startups & Small Businesses"
            ]
        },
        trustSection: [
            {
                heading: "Salesforce Consulting for Startups in Mumbai",
                description: "If you are a startup looking to manage leads, automate sales processes, and scale faster, our Salesforce consulting services are the perfect solution. We help startups implement cost-effective Salesforce solutions that grow along with the business."
            },
            {
                heading: "Why Businesses in Mumbai Trust Us",
                description: "We have helped many businesses improve their sales process, customer engagement, and business performance through Salesforce solutions. Our team focuses on delivering high-quality services with measurable results."
            }
        ],
        processSection: {
            heading: "Our Process",
            steps: [
                {
                    id: "01",
                    title: "Business Analysis",
                    desc: "We understand your business goals, workflow, and challenges."
                },
                {
                    id: "02",
                    title: "Planning & Strategy",
                    desc: "We create a tailored roadmap to implement Salesforce effectively."
                },
                {
                    id: "03",
                    title: "Implementation",
                    desc: "Our experts set up and configure your CRM environment."
                },
                {
                    id: "04",
                    title: "Data Migration",
                    desc: "Securely transferring your existing data into the new system."
                },
                {
                    id: "05",
                    title: "Training & Support",
                    desc: "Empowering your team with training and ongoing assistance."
                }
            ]
        }
    },
    
    ...dynamicServiceNowData
];